import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Paragraph, Separator } from '@fs/zion-ui'
import { DocumentBasic } from '@fs/zion-icon'
import { Link } from '@fs/zion-router'
import faqData from './faqData'
import handleClickRecordDetails from '../../../../utils/handleClickRecordDetails'
import usePrisonAccess from '../../../../../Give/hooks/usePrisonAccess'

const FAQContent = ({ personId, currentStep, handleGoToNextRecordAndResetStep, hasImagePermission }) => {
  const { t } = useTranslation()
  const { accessFromPrison, isReady } = usePrisonAccess()

  return (
    <Paragraph as="div" size="sm">
      <ol>
        {faqData
          .filter((faq) => faq.showOnSteps.includes(currentStep))
          .map((faq) => (
            <div key={`${faq.questionKey}-${faq.answerKey}`}>
              <strong>
                <li>{t(faq.questionKey, faq.questionDefault)}</li>
              </strong>
              <Separator size="nano" />
              <Paragraph size="sm">{faq.answerDefault}</Paragraph>
              {'learnMoreLink' in faq && !accessFromPrison && isReady && (
                <>
                  <Separator size="nano" />
                  <Link to={faq.learnMoreLink} target="_blank" rel="noopener noreferrer">
                    {t('family-review.faq.learn-more', 'Learn More')}
                  </Link>
                </>
              )}
              {faq.questionKey === 'family-review.faq.question3' && (
                <>
                  {personId && hasImagePermission && !accessFromPrison && isReady && (
                    <Button
                      emphasis="low"
                      Icon={DocumentBasic}
                      onClick={() => handleClickRecordDetails(personId)}
                      data-testid="record-details"
                      linkName="Tip Record Details"
                    >
                      {t('navigation.details-button', 'Record Details')}
                    </Button>
                  )}
                  <Paragraph size="sm">
                    {t(
                      'family-review.step1.in-most-cases',
                      'In most cases, we recommend going to the next record and continuing with Indexing Review'
                    )}
                    <Button
                      emphasis="low"
                      onClick={handleGoToNextRecordAndResetStep}
                      data-testid="go-to-next-record"
                      linkName="Tip Go To Next Record"
                    >
                      {t('family-review.step2.go-to-next-record', 'Go To Next Record')}
                    </Button>
                  </Paragraph>
                </>
              )}
              <Separator size="xs" />
            </div>
          ))}
      </ol>
    </Paragraph>
  )
}

export default FAQContent
